package com.trevorwiebe.timesheet.admin.usermanagement.data

import kotlinx.serialization.Serializable

// Typed payloads for the callable Cloud Functions. GitLive's `invoke<T>(data)`
// encodes these via their generated serializers, so booleans/numbers cross the
// wire as real booleans/numbers (no client-side stringification, no server-side
// coercion).

@Serializable
data class CreateUserRequest(
    val name: String,
    val email: String,
    val organizationId: String,
    val payEntryId: String,
    val nickname: String,
    val hireDate: String,
    val ptoBalance: Int,
    val fullTime: Boolean,
    val holidayTime: Boolean,
    val role: String,
    val ownerOperatorId: String? = null,
)

@Serializable
data class UpdateUserRequest(
    val uid: String,
    val email: String,
    val displayName: String,
)

@Serializable
data class SetUserDisabledRequest(
    val uid: String,
    val disabled: Boolean,
)
